<template>
  <navbar inverse>
    <template slot="collapse">
      <navbar-nav>

        <router-link v-for="l in sc.links" :key="`${l.name}-router-link`"
                     tag="li" active-class="active" :class="{ active: l.unfold }"
                     :to="`/${l.name}`" event="">
          <a v-if="l.items != null && l.items.length > 0" role="button"
             @click.prevent=""
             @mouseover="l.unfold = true" @mouseleave="l.unfold = false">
            <dropdown tag="div"
                      role="button" v-model="l.unfold">
              <div @click.prevent="">{{ l.text }} <span class="caret"></span></div>
              <template slot="dropdown">
                <router-link v-for="i in l.items" tag="li"
                             class="no-outline"
                             :key="`${l.name}-${i.key} router-link`"
                             :to="`/${i.link}`">
                  <a role="button">{{ i.text }}</a>
                </router-link>
              </template>
            </dropdown>
          </a>
          <a router-link v-else tag="a" role="button" class="no-outline">
            {{ l.text }}
          </a>
        </router-link>
      </navbar-nav>

      <navbar-text v-if="isLoggedIn" right>
        <strong>{{ name }}</strong>
        (<a @click="logout" class="navbar-link">Se déconnecter</a>)
      </navbar-text>
      <navbar-text v-else right>
        <a @click="login" class="navbar-link">Se connecter</a>
      </navbar-text>
    </template>
  </navbar>
</template>
<script>

import { mapGetters } from 'vuex'

const sc = {
  links: [
    { name: 'home', text: 'Accueil' },
    { name: 'program', text: 'Programme 2026' },
    {
      name: 'results',
      text: 'Résultats & Rapports',
      items: [
        {
          key: '2025',
          link: 'results?tab=0',
          text: 'Année 2025'
        },
        {
          key: '2024',
          link: 'results?tab=1',
          text: 'Année 2024'
        },
        {
          key: '2023',
          link: 'results?tab=2',
          text: 'Année 2023'
        },
        {
          key: '2022',
          link: 'results?tab=3',
          text: 'Année 2022'
        },
        {
          key: '2021',
          link: 'results?tab=4',
          text: 'Année 2021'
        },
        {
          key: '2020',
          link: 'results?tab=5',
          text: 'Année 2020'
        },
        {
          key: '2019',
          link: 'results?tab=6',
          text: 'Année 2019'
        },
        {
          key: '2018',
          link: 'results?tab=7',
          text: 'Année 2018'
        }
      ],
      unfold: false
    },
    {
      name: 'missionday',
      text: 'Formation',
      items: [
        {
          key: '2026',
          link: 'missionday?tab=0',
          text: 'Journée Nationale SPIADI2026'
        },
        {
          key: '2025',
          link: 'missionday?tab=1',
          text: 'Journée Nationale SPIADI2025'
        },
        {
          key: '2024',
          link: 'missionday?tab=2',
          text: 'Journée Nationale SPIADI2024'
        },
        {
          key: '2023',
          link: 'missionday?tab=3',
          text: 'Journée Nationale SPIADI2023'
        },
        {
          key: '2022',
          link: 'missionday?tab=4',
          text: 'Journée Nationale SPIADI2022'
        },
        {
          key: '2021',
          link: 'missionday?tab=5',
          text: 'Journée Nationale SPIADI2021'
        },
        {
          key: '2020',
          link: 'missionday?tab=6',
          text: 'Journée Nationale SPIADI2020'
        },
        {
          key: '2019',
          link: 'missionday?tab=7',
          text: 'Journée Nationale SPIADI2019'
        }
      ],
      unfold: false
    },
    {
      name: 'groups',
      text: 'Groupes de travail'
    },
    {
      name: 'tools',
      text: 'Outils',
      items: [
        { key: 'tech', link: 'tools?tab=0', text: 'Fiches techniques' },
        { key: 'educ', link: 'tools?tab=1', text: 'Outils pédagogiques' },
        { key: 'train', link: 'tools?tab=2', text: 'Supports de formation' }
      ],
      unfold: false
    },
    {
      name: 'valuation',
      text: 'Valorisation',
      items: [
        { key: 'com', link: 'valuation?tab=0', text: 'Communications' },
        { key: 'collab', link: 'valuation?tab=1', text: 'Collaborations' },
        { key: 'pub', link: 'valuation?tab=2', text: 'Publications' }
      ],
      unfold: false
    },
    { name: 'establishments', text: 'Mon Espace' },
    {
      name: 'help',
      text: 'Actu-SPIADI',
      items: [
        { key: 'news', link: 'help?tab=0', text: 'Actu-SPIADI' },
        { key: 'faq', link: 'help?tab=1', text: 'FAQ' }
      ],
      unfold: false
    },
    { name: 'contact', text: 'Contact' }
  ]
}

export default {
  name: 'navigation',

  data: function () {
    return {
      sc: sc
    }
  },

  computed: {
    ...mapGetters({
      isLoggedIn: 'user/isLoggedIn',
      name: 'user/completeName'
    })
  },

  methods: {
    logout: function () {
      this.$store.dispatch('user/logout', 'user')
      this.$router.push('/')
    },

    login: function () {
      this.$router.push('/login')
    }
  }
}
</script>
<style scoped lang="less">
@import '~mixins';

.navbar {
  margin-bottom: 0px;

  .nav li a{
    margin-top: 0.5rem;
    padding: 1rem;
  }

  .navbar-link {
    .underlined-link();
  }

  .navbar-right {
    margin-right: 0rem;
  }
}
</style>
<style lang="less">
@import '~variables';
.navbar {
  .dropdown-menu {
    border-width: 0rem;
    background-color: @navbar-inverse-link-active-bg;
    margin-left: -1rem;
    margin-top: 7px;
    padding-top: 0rem;
    box-shadow: 6px 6px 3px rgba(0, 0, 0, 0.175);

    a, a:focus {
      color: @navbar-inverse-link-active-color;
      background-color: @navbar-inverse-link-active-bg;
      margin-top: 0rem;
    }

    a:hover {
      background-color: @navbar-inverse-bg;
      color: @navbar-inverse-color;
    }
  }
}
</style>
